<script lang="ts" setup>
	import { passwordRulePass, setPassWord, passwordValidationDemands } from './constant'

	const {
		placeholder = 'Enter your password',
		validate = true,
		showValidationLabel = true
	} = defineProps<{
		placeholder?: string
		validate?: boolean
		showValidationLabel?: boolean
	}>()
	const formState = ref<{ password: string }>({
		password: ''
	})

	const emit = defineEmits<{
		(e: 'change', value: string): void
	}>()
	const defaultValue = shallowRef('')

	const passwordValue = defineModel<string>()

	const attr = useAttrs()
	watch(defaultValue, val => {
		if (validate) {
			setPassWord.value = val
			if (passwordRulePass.value) {
				passwordValue.value = formState.value.password
				emit('change', formState.value.password)
			} else {
				passwordValue.value = ''
				emit('change', '')
			}
		} else {
			passwordValue.value = val
			emit('change', val)
		}
	})
</script>

<template>
	<div class="flex flex-col">
		<a-input-password
			v-model:value="defaultValue"
			autocomplete="new password"
			data-testid="password"
			class="custom-input w-full !bg-gray-100 !px-5 sm:mb-3"
			:placeholder
			v-bind="attr"
		/>
		<lazy-form-item-password-message
			v-if="showValidationLabel"
			:password-validation-demands="passwordValidationDemands"
		/>
	</div>
</template>
